// extracted by mini-css-extract-plugin
module.exports = {"button":"Password_button__32kog","buttons":"Password_buttons__3V8A4"};